import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BlobResponse } from '../../Models/OtherClasses';
import { BaseService } from "../BaseService";
import { UrlService } from "../UrlService";

@Injectable()
export class PropertyItemService {
	private url: string;

	constructor(
		private myBaseService: BaseService,
		private urlService: UrlService
	) {
		this.url = urlService.getURL('PropertyItem');
	}

	loadHistoryForItem(id: System.Guid): Observable<TooBig4Car.Logic.IStorageHistory[]> {
		return this.myBaseService.loadAll(this.url + '/HistoryForItem/' + (id ?? ''));
	}
	loadShipmentsForItem(id: System.Guid): Observable<TooBig4Car.Logic.IStorageHistory[]> {
		return this.myBaseService.loadAll(this.url + '/ShipmentsForItem/' + (id ?? ''));
	}
	loadSpecialItemsForItem(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemSpecialItem[]> {
		return this.myBaseService.loadAll(this.url + '/SpecialItemsForItem/' + (id ?? ''));
	}
	loadForShipment(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForShipment/' + (id ?? ''));
	}
	loadAllForSpace(spaceID: System.Guid): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForSpace/' + (spaceID || ''));
	}
	downloadAllForSpace(spaceID: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.postBlob(null, this.url + '/DownloadForSpace/' + (spaceID || ''));
	}
	loadAllNeedingInspection(): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/NeedsInspection');
	}
	loadAllNeedingRepair(): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/NeedsRepair');
	}
	loadAllNeedingStorage(): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/NeedsStorage');
	}
	loadStoredForCustomer(custID: System.Guid, includeAll: boolean): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.loadAll(this.url + '/ForCustomer/' + (custID || '') + '?includeAll=' + (includeAll ?? false).toString());
	}
	unstore(tempItem: TooBig4Car.Logic.PropertyItemArbitraryDeliveryVM): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.save(tempItem, this.url + '/Unstore');
	}
	markWarhouseAssemblyDone(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.save(null, this.url + '/WarehouseAssemble/' + (id || ''));
	}
	changeCustomer(searchObj: TooBig4Car.Logic.PropertyItemCustomerChangeVM): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.post(searchObj, this.url + '/ChangeCustomer', true);
	}
	save(tempItem: TooBig4Car.Logic.PropertyItem): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.save(tempItem, this.url);
	}
	saveCustomerFields(tempItem: TooBig4Car.Logic.PropertyItemCustomerVM): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.post(tempItem, this.url + '/Customer/', true);
	}
	saveSpecialItem(tempItem: TooBig4Car.Logic.PropertyItemSpecialItem): Observable<TooBig4Car.Logic.PropertyItemSpecialItem> {
		return this.myBaseService.save(tempItem, this.url + '/SpecialItem');
	}
	deleteItem(id: System.Guid): Observable<boolean> {
		return this.myBaseService.deleteItem(id, this.url);
	}
	getEdit(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.getEdit(id, this.url);
	}
	getEditCustomer(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItemCustomerVM> {
		return this.myBaseService.get(id, this.url + '/EditCustomer');
	}
	get(id: System.Guid): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.get(id, this.url);
	}
	getStorageLabel(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id ?? '') + '/StorageLabel');
	}
	getShipmentBOLLabel(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id ?? '') + '/ShipmentStorageLabels');
	}
	getUploadedFileLabels(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id ?? '') + '/UploadedFileStorageLabels');
	}
	getQRCode(id: System.Guid): Observable<BlobResponse> {
		return this.myBaseService.loadBlob(this.url + '/' + (id ?? '') + '/QR');
	}
	searchText(name: string): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.post(name, this.url + '/SearchText', false);
	}

	searchDetailed(searchObj: TooBig4Car.Logic.SearchVM): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.post(searchObj, this.url + '/Search?download=false', false);
	}

	searchDetailedDownload(searchObj: TooBig4Car.Logic.SearchVM): Observable<BlobResponse> {
		return this.myBaseService.postBlob(searchObj, this.url + '/Search?download=true');
	}

	move(moveObj: TooBig4Car.Logic.PropertyItemMoveVM): Observable<TooBig4Car.Logic.PropertyItem> {
		return this.myBaseService.post(moveObj, this.url + '/Move', false);
	}
	moveBulk(moveObj: TooBig4Car.Logic.PropertyItemMoveBulkVM): Observable<TooBig4Car.Logic.PropertyItem[]> {
		return this.myBaseService.post(moveObj, this.url + '/MoveBulk', false);
	}
	bulkAction(obj: TooBig4Car.Logic.PropertyItemBulkActionVM): Observable<any> {
		return this.myBaseService.post(obj, this.url + '/Bulk', true);
	}
}

